<template>
  <div v-if="show">
    <v-card
      flat
      tile
      :min-height="minHeight"
      :color="bgcolor"
      :class="classname"
    >
      <v-container class="">
        <div :id="storeKey"></div>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import EditorJS from "@editorjs/editorjs";
import Header from "@editorjs/header";
// import List from "@editorjs/list";
import Table from "@editorjs/table";
import Checklist from "@editorjs/checklist";
import Code from "@editorjs/code";
import Delimiter from "@editorjs/delimiter";
import Embed from "@editorjs/embed";
import InlineCode from "@editorjs/inline-code";
import Link from "@editorjs/link";
import Marker from "@editorjs/marker";
import NestedList from "@editorjs/nested-list";
import Raw from "@editorjs/raw";
//import SimpleImage from "@editorjs/simple-image";
import Underline from "@editorjs/underline";
import Warning from "@editorjs/warning";
import Quote from "@editorjs/quote";
import Paragraph from "editorjs-paragraph-with-alignment";
import AlignmentBlockTune from "editorjs-text-alignment-blocktune";
import ImageTool from "@editorjs/image";
// import Collapse from '@groupher/editor-collapse';
import * as Collapse from "../assets/js/collapse.js";

import {
  GetWebsiteBasicContent,
  GetWebsiteBasicContentVer,
} from "@/api/publicServices";
import { getLS, setLS } from "@/api/common";

export default {
  props: {
    storeKey: {
      type: String,
      required: true,
    },
    bgcolor: {
      type: String,
      default: "transparent",
    },
    classname: {
      type: String,
      default: "black--text",
    },
  },
  data: () => ({
    contentArea: null,
    minHeight: 100,
    show:true,
  }),
  created() {
    this.contentArea = new EditorJS({
      holder: this.storeKey,
      readOnly: true,
      onReady: () => {
        this.getInfo();
      },
      minHeight: 0,
      tools: {
        header: {
          class: Header,
          tunes: ["textAlignTune"],
        },
        // list: List,
        list: NestedList,
        table: Table,
        paragraph: {
          class: Paragraph,
          inlineToolbar: true,
        },
        checklist: Checklist,
        code: Code,
        delimiter: Delimiter,
        embed: Embed,
        "inline-code": InlineCode,
        link: Link,
        marker: Marker,
        "nested-list": NestedList,
        raw: Raw,
        image: ImageTool,
        underline: Underline,
        quote: Quote,
        warning: Warning,
        textAlignTune: {
          class: AlignmentBlockTune,
          config: {
            default: "left",
            blocks: {
              header: "center",
            },
          },
        },
        collapse: {
          class: Collapse,
          config: {},
        },
      },
    });
  },
  mounted() {},
  methods: {
    async getVer() {
      try {
        const response = await GetWebsiteBasicContentVer({});
        localStorage.setItem("isGetWebsiteBasicContentVer", "true");
        return response.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getInfo() {
      try {
        let version;
        let currentVersion = localStorage.getItem("version");
        console.log(`isGetWebsiteBasicContentVer: ${localStorage.getItem("isGetWebsiteBasicContentVer")}`);
        if (localStorage.getItem("isGetWebsiteBasicContentVer") == "true") {
          version = currentVersion;
        } else {
          version = await this.getVer();
        }

        let content = "";
        if (version == currentVersion) {
          let content = getLS(this.storeKey);
          if (content != null) {
            this.contentArea.blocks.clear();
            this.contentArea.blocks.render(JSON.parse(content.Description));
            return;
          }
        }

        const response = await GetWebsiteBasicContent({});
        let profiles = response.data;

        for (let index in profiles) {
          setLS(profiles[index].ContentType, profiles[index], 6000);
        }

        localStorage.setItem("version", version + "");

        content = getLS(this.storeKey);
        this.contentArea.blocks.clear();
        if (content != null) {
          this.contentArea.blocks.render(JSON.parse(content.Description));
        } else {
          this.show = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.contentArea {
  max-width: 500px;
  padding: 20px;
  margin-top: 50px;
  /* margin-right: 70px; */
}
</style>
